export const handleRemoveFieldInGroup = (
  groupId: string | undefined,
  fieldId: string,
  form: any,
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  uuid: string,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const removeFieldRecursively = (items: any[]): any[] => {
    return items
      .map((item: any) => {
        if (item.uuid === groupId || item.id === fieldId) {
          if (item.children) {
            return {
              ...item,
              children: removeFieldRecursively(
                item.children.filter(
                  (field: any) => field.uuid !== uuid || field.id !== fieldId
                )
              ),
            };
          }
        } else if (item.children) {
          return {
            ...item,
            children: removeFieldRecursively(item.children),
          };
        }
        return item;
      })
      .filter((field) => field.uuid !== fieldId);
  };

  const newItems = removeFieldRecursively(form);
  setForm(newItems);
  setButtonSave(true);
};
